import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import { Typography, Stack, Box, Button, IconButton } from "@mui/material";
import "../../../../Style/pageStyle.scss";
import { useLocation } from "react-router-dom";
import { useQuery } from "@apollo/client";
import moment from "moment";
// icon
import { MdEditNote } from "react-icons/md";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";

// src
import { AuthContext } from "../../../../Context/AuthContext";
import { translateLauguage } from "../../../../Function/Translate";
import StudentEnrollmentAction from "./StudentEnrollmentAction";
import StudentEnrollmentForm from "./StudentEnrollmentForm";
import { SelectAcademicYear } from "../../../../Function/DynamicSelect";
import EmptyData from "../../../../Components/Include/EmptyData";
import LoadingPage from "../../../../Components/Include/LoadingPage";
import { GET_CLASS_ATTENDED_BY_STUDENT } from "../../../../Schema/Student";

export default function StudentEnrollment() {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  let stuId = params.get("id");

  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const [academicYearVal, setAcademicYearVal] = useState({ id: "", title: "" });
  const [editData, setEditData] = useState();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event, val) => {
    setAnchorEl(event.currentTarget);
    setEditData(val);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [openCreate, setOpenCreate] = useState(false);
  const handleOpenCreate = () => setOpenCreate(true);
  const handleCloseCreate = () => setOpenCreate(false);

  const { refetch } = useQuery(GET_CLASS_ATTENDED_BY_STUDENT, {
    variables: {
      studentId: stuId,
      academicYearId: academicYearVal?.id,
    },
    onCompleted: ({ getClassAttendedByStudent }) => {
      setLoading(false);
      setTableData(getClassAttendedByStudent);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [stuId]);

  // console.log("editData?._id",editData?._id)

  return (
    <div className="page-container">
      <Box>
        <Grid container spacing={2}>
          <Grid size={{ xs: 2 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`academic_year`)}
            </Typography>
            <SelectAcademicYear
              selectedVal={academicYearVal}
              setSelectedVal={setAcademicYearVal}
              className="search-field"
            />
          </Grid>

          <Grid size={{ xs: 10 }}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpenCreate}
                className="btn-create-style"
                startIcon={<AddToPhotosIcon className="icon-add" />}
              >
                <Typography
                  className={language === "kh" ? "btn-txt-kh" : "btn-txt"}
                >
                  {t("btn-create")}
                </Typography>
              </Button>
              <StudentEnrollmentForm
                open={openCreate}
                handleClose={handleCloseCreate}
                setRefetch={refetch}
              />
            </Stack>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ marginTop: "25px" }}>
        <Grid container spacing={2}>
          {loading ? (
            <Grid size={{ xs: 12 }}>
              <LoadingPage />
            </Grid>
          ) : (
            <>
              {tableData?.length === 0 ? (
                <Grid size={{ xs: 12 }}>
                  <EmptyData />
                </Grid>
              ) : (
                <>
                  {tableData?.map((item, index) => {
                    // console.log("item", item);
                    return (
                      <Grid size={{ xs: 3 }} key={index}>
                        <Stack
                          direction="column"
                          spacing={1}
                          className="card-enrollment-container"
                        >
                          <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Stack
                              className={
                                item?.is_last_class === true && item?.is_drop_out === true ? "inactive-status"
                                  : item?.is_finished_class === true && item?.certificate_offer_status === "Next_Class" ? "finish-status"
                                  : item?.is_finished_class === true && item?.certificate_offer_status === "Offer" ? "offer-status"
                                    : "active-status"
                              }
                            >
                              <Typography
                                className={
                                  language === "en"
                                    ? "status-txt"
                                    : "status-txt-kh"
                                }
                              >
                                {
                                  item?.is_last_class === true && item?.is_drop_out === true ? t("drop_out")
                                    : item?.is_finished_class === true && item?.certificate_offer_status === "Next_Class" ? t("next_level")
                                    : item?.is_finished_class === true && item?.certificate_offer_status === "Offer" ? t("certificate_offer")
                                      : t("studying")}
                              </Typography>
                            </Stack>
                            <IconButton onClick={(e) => handleClick(e, item)}>
                              <MdEditNote />
                            </IconButton>
                          </Stack>
                          <Stack direction="column">
                            <Typography className="group-title">
                              {item?.class_id?.level_id?.level_name +
                                " " +
                                item?.class_id?.group_id?.group_name}
                            </Typography>
                            <Typography className="school-title">
                              {language === "kh"
                                ? item?.class_id?.school_id?.school_name
                                : item?.class_id?.school_id?.school_name_en}
                            </Typography>
                          </Stack>
                          <Stack
                            direction="column"
                            className="detail-container"
                            spacing={0.5}
                          >
                            <Stack direction="row">
                              <Typography
                                className={language === "en" ? "txt" : "txt-kh"}
                                width={`40%`}
                              >
                                {t(`academic_year`)}
                              </Typography>
                              <Typography
                                className={language === "en" ? "txt" : "txt-kh"}
                                width={`10%`}
                              >
                                :
                              </Typography>
                              <Typography
                                className={language === "en" ? "txt" : "txt-kh"}
                                idth={`50%`}
                              >
                                {
                                  item?.class_id?.academic_year_id
                                    ?.academic_year
                                }
                              </Typography>
                            </Stack>
                            <Stack direction="row">
                              <Typography
                                className={language === "en" ? "txt" : "txt-kh"}
                                width={`40%`}
                              >
                                {t("join_date")}
                              </Typography>
                              <Typography
                                className={language === "en" ? "txt" : "txt-kh"}
                                width={`10%`}
                              >
                                :
                              </Typography>
                              <Typography
                                className={language === "en" ? "txt" : "txt-kh"}
                                width={`50%`}
                              >
                                {moment(item?.join_date).format("DD-MM-YYYY")}
                              </Typography>
                            </Stack>
                          </Stack>
                        </Stack>
                      </Grid>
                    );
                  })}
                </>
              )}
            </>
          )}
        </Grid>
      </Box>

      <StudentEnrollmentAction
        handleClose={handleClose}
        anchorEl={anchorEl}
        open={open}
        editData={editData}
        setRefetch={refetch}
        enrollmentTypeAction="student_page_inside"
      />
    </div>
  );
}
